import { createAddressObj, createAddressObj_  } from "./address";


const ret_file_desc = (files)=> files.map(cert=>({_id: cert._id, name: cert.file.name, size: cert.file.size || 0, type: cert.file.mime}));


const getBenefit = (benefit) =>{

const benetit_obj = {
      type: '',
      documentType: '',
      documentNumber: '',
      issuedTo: '',
      issueDate: '',
      files: [],
      address: {
        district: '',
        street: '',
        building: '',
        corpus: ''
      }
};

if(!benefit || benefit.length < 1) return benetit_obj;

const ben = benefit[0];

if(!ben || !ben.benefitId) return benetit_obj;

benetit_obj.type = ben.benefitId;
benetit_obj.documentType = ben.documentType;
benetit_obj.documentNumber = ben.documentNumber;
benetit_obj.issuedTo = ben.documentTo;
benetit_obj.issueDate = ben.documentIssueDate;
//benetit_obj.address = createAddressObj_(ben.address);
benetit_obj.files = ret_file_desc(ben.benScan);

return benetit_obj;

};



export function convertReqToForm(req){


    const { _id, child, responsiblePerson, specialization, neededPlaceDescription, dictionary, criterias } = req;

    const { benefits } = child;

    const ben = benefits[0] || {};


    console.log({ function: 'convertReqToForm', passport: responsiblePerson.passport})

    let _dictionary = {};


    try{

        _dictionary = JSON.parse(dictionary)
    
    } catch(err){
        console.log('error parse. dictionary: ', dictionary);
    }



    return(
        {    
            _id,
            child: {
                lastName: child.lastName,
                firstName: child.firstName,
                middleName: child.seconName,
                birthDate: child.birthDate,
                gender: child.gender,
                birthCertificate: {
                    seriesNumber: child.birthCertificate.number,
                    issueDate: child.birthCertificate.issueDate,
                    country: child.birthCertificate.issueCountry,
                    files: ret_file_desc(child.certScan)
                },
                address: createAddressObj_(child.addressDictYur),
                addressFact: createAddressObj_(child.addressDictFact),
                sameFactAddress: child.sameFactAddress
                },
            applicant: {
                lastName: responsiblePerson.lastName,
                firstName: responsiblePerson.firstName,
                middleName: responsiblePerson.seconName,
                citizenship: responsiblePerson.citizenship,
                rnokpp: responsiblePerson.code,
                phone: responsiblePerson.contacts.phone,
                email: responsiblePerson.contacts.email,
                address: createAddressObj_(responsiblePerson.addressDict),
                documentType: responsiblePerson.typeOfDoc,
                documentDetails: responsiblePerson.documentDetails || '',
                hasRnokpp: responsiblePerson.typeOfDoc && responsiblePerson.typeOfDoc == "code" ? "yes": "no"
            },
            preferences: {
                desiredDate: req.preferDateFrom,
                inclusiveGroup: neededPlaceDescription.inclusive,
                specialization: specialization.specializationId || false, 
                diseaseType: specialization.specializationId,
                diseaseDocument: {
                    type: specialization.typeOfDoc,
                    number: specialization.medicalProtocol  ,
                    issuedTo: specialization.issueTo,
                    issueDate: specialization.issueDate,
                    files: ret_file_desc(specialization.docScan)
                }
            },
            benefits: getBenefit(benefits),
            selectedSchools: criterias && criterias[0] && criterias[0].values && criterias[0].values || [],
            agreePersonalData: "yes",
            dictionary: _dictionary
        }
    )
}